import { ErrorHandler, Injectable } from '@angular/core';
import { TrackingService } from 'src/app/shared/services/tracking.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private trackingService: TrackingService) { }

  handleError(error: any): void {
    console.warn(error.message);

    // Send the native error object to TrackJS
    this.trackingService.track(error.originalError || error);
  }
}
